import React from 'react';
import { connect } from 'react-redux';
import PageHeaderView from '../view-project-header';
const fakeProfile = props => ({
  firstName: props.firstName
});
const fakeFacilitator = {
  firstName: 'Florence'
};
const fakeSeller = {
  firstName: 'Kévin'
};
const FakeHeaderContainer = props => /*#__PURE__*/React.createElement(PageHeaderView, {
  profile: fakeProfile(props),
  facilitator: fakeFacilitator,
  seller: fakeSeller
});
const mapStateToProps = _ref => {
  let {
    draft
  } = _ref;
  return {
    firstName: draft.draftContent.firstName
  };
};
export default connect(mapStateToProps, null)(FakeHeaderContainer);